import Vue from 'vue'
import Vuex from 'vuex'
import documentsService from '../api/documents.js'

Vue.use(Vuex)

const initialState = {
  personDocuments: {},
  documentsOrder: []
}

const getters = {
  personDocuments(state) {
    return state.personDocuments
  },
  documentsOrder(state) {
    return state.documentsOrder
  }
}

export const mutations = {
  setDocumentOrder(state, payload) {
    state.documentsOrder = payload
  }
}

export const actions = {
  async saveDocumentsOrder(context, payload) {
    try {
      const response = await documentsService.saveDocumentsOrder(payload);
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getDocumentsOrder(context, payload) {
    try {
      const response = await documentsService.getDocumentsOrder(payload);
      context.state.documentsOrder = response.data;
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPersonDocuments(context, payload) {
    try {
      const response = await documentsService.getPersonDocuments(payload);
      context.state.personDocuments = response.data
      return Promise.resolve();
    } catch (error) {
      const errorMessage = context.rootState.langObj.response.error[error.response.data] || context.rootState.langObj.response.error.somethingWentWrong;
      context.commit('toast', { message: errorMessage, color: 'red lighten-2' }, { root: true });
      return Promise.reject(error);
    }
  },
  async deletePersonDocument(context, payload) {
    try {
      const response = await documentsService.deletePersonDocument(payload);
      context.commit('toast', { message: context.rootState.langObj.response.success.deleteDocument, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  }
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
